import React from "react";
import { Button } from "@pacificoseguros/pixie/react/button";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";
import classNames from "classnames";
import { useChannel } from "../../../libs/channels/hooks/use-channel";

export const QuotationPopupSubmitButton: React.FC = () => {
    const {
        formState: { isValid },
    } = useQuotationPopupFormContext();
    const { isBcpTheme } = useChannel();
    return (
        <Button
            data-testid="QuotationPopupSubmitButton"
            id="quotation-popup-submit"
            type="submit"
            kind="primary"
            disabled={!isValid}
            className={classNames({
                bcp: isBcpTheme,
            })}
        >
            Continuar
        </Button>
    );
};
